import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import history from 'history/browser';
import { images } from "..";
import '../../Pages/Home/style.sass'

const LearnFromLeader = () => {
    let location = history.location;
    const [instructorsData, setInstructorsData] = useState([])
    // get all instructors and save it in constant
    const [
        allInstructorsData
    ] = useSelector((state) => {
        return [
            state.instructors.allInstructorsList
        ]
    });
    // save all instructors data related things into usestates
    useEffect(() => {
        setInstructorsData(allInstructorsData)
    }, [allInstructorsData])
    return (
        <div className="fifth-section">
            <div className="container py-5 my-md-5">
                <div className="row mx-0">
                    <div className="col-md-6 mx-auto text-center">
                        <h1 className='heading'>
                            Learn from Leaders
                        </h1>
                        {/* <h1 className='heading mb-0'>
                        Esteemed
                    </h1>
                    <h1 className='heading'>
                        Educators this summer.
                    </h1> */}
                        {/* <p className="summary mt-3">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque viverra sed neque at vestibulum. Pellentesque maximus urna magna, nec tempor libero consequat at. Nunc nec.
                    </p> */}
                    </div>
                </div>
                <div className="row mx-0">
                    {instructorsData.map((data, key) => (
                        <div className="col-md-4 col-lg-3 my-4 text-center mainHoverEffect" key={key}>
                            <div className="newHoverEffect">
                                <img src={data.image} alt="Educators" className="educator-img img-fluid" />
                                <p className="instructor_bio">
                                    {data.bio}
                                </p>
                            </div>
                            <h4 className="name mb-1 mt-3">{data.title} {data.firstName} {data.lastName}</h4>
                            <p className="summary mb-0 mx-lg-5 mx-3">
                                {data.tagline}
                            </p>
                        </div>
                    ))}
                    <div className="col-md-12 my-4 d-flex justify-content-center">
                        <a href="https://www.beecadvantage.com/" target={'_blank'}>
                            <img
                                src={images.logoBordered}
                                className="img-fluid"
                                alt="Summer-Web Logo"
                            />
                        </a>
                        {location.pathname == '/' ?
                            <a href="https://www.cpmentorship.org/" target={'_blank'} className='ms-3'>
                                <img
                                    src={images.mentorshipLogo}
                                    className="img-fluid"
                                    alt="Summer-Web Logo"
                                />
                            </a> :
                            <a href="#" className='ms-3'>
                                <img
                                    src={images.santaUniversity}
                                    className="img-fluid"
                                    alt="Summer-Web Logo"
                                />
                            </a>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LearnFromLeader